

































import Vue from 'vue';
import { Prop, Component, Model, Watch } from 'vue-property-decorator';

/**
 * Helpers
 */
import { differenceInMinutesBetweenHoursMinutes } from "@/utils/date-helpers";

/**
 * Composant d'éditeur TimePicker.
 */
@Component
export default class TimePickerInput extends Vue {
	/** Propriétés */
	@Prop()
	min!: string;

	@Prop()
	max!: string;

	@Prop()
	allowedMinutes!: (m: number) => boolean;

	/** v-model */
	@Model('time-changed')
	time!: string;

	/** Attributs */
	internalTime: string | null = null;
	menu = false;



	/** Méthodes */
	created() {
		this.internalTime = this.time;
	}

	/** Watchers */
	@Watch('internalTime')
	internalTimeChanged() {
		this.$emit('time-changed', this.internalTime);
	}

	@Watch('time')
	timeChanged() {
		this.internalTime = this.time;
	}

	@Watch('min')
	minChanged() {
		if (this.internalTime && differenceInMinutesBetweenHoursMinutes(this.min, this.internalTime) < 0) {
			this.internalTime = this.min;
		}
	}

	@Watch('max')
	maxChanged() {
		if (this.internalTime && differenceInMinutesBetweenHoursMinutes(this.max, this.internalTime) > 0) {
			this.internalTime = this.max;
		}
	}

	@Watch('menu')
	menuChanged() {
		this.$emit('onOpenChanged', this.menu);
	}
}
